/* ==========================================================================
   smellBgone stockists map — full Leaflet port of
   app/components/stockistMapBoot.client.ts (the design's componentDidMount).

   Enhances the server-rendered DOM (#stockists-map, #stockist-list,
   #stockist-state, #stockist-near, #stockist-reset, #stockist-filter-label):
   custom teardrop garden-cart pins + numbered cluster pins, a turf-texture
   overlay clipped to the Australian landmass with white state borders, and
   click-a-state-to-filter that drives both the map and the (JS-rebuilt) list.
   Falls back to CARTO tiles whenever neither ground is available — the states
   GeoJSON can't be fetched, or it can but the turf texture can't (theme-only).

   Reads [data-stockists-json] ({name,address,suburb,state,postcode,phone,
   website,notes,lat,lng}). Requires leaflet.js + leaflet.markercluster.js.
   ========================================================================== */
(function () {
  // Coerce every field to a string — metaobject fields can arrive as objects
  // (url/reference types) or null, and the map code calls .trim() on them.
  function str(v) {
    return v == null || typeof v === 'object' ? '' : String(v);
  }
  function toRow(s) {
    return {
      Name: str(s.name),
      Address: str(s.address),
      Suburb: str(s.suburb),
      State: str(s.state),
      Postcode: str(s.postcode),
      Country: str(s.country),
      Latitude: str(s.lat),
      Longitude: str(s.lng),
      Phone: str(s.phone),
      Website: str(s.website),
      Email: str(s.email),
      Notes: str(s.notes),
    };
  }

  function boot(stockists) {
    var CONFIG = {
      tile: {
        url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 19,
      },
      cluster: {
        maxClusterRadius: 45,
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        disableClusteringAtZoom: 8,
      },
      // Same fit options the app declares (stockistMapBoot.client.ts:65). Used
      // by the theme-only state-filter fallback below.
      fit: { padding: [50, 50], maxZoom: 8 },
    };

    var el = document.getElementById('stockists-map');
    if (!el || el._init) return;
    el._init = true;

    var esc = function (t) {
      var d = document.createElement('div');
      d.textContent = t == null ? '' : String(t);
      return d.innerHTML;
    };
    var fmtPhone = function (p) {
      if (!p) return '';
      var d = p.replace(/\D/g, '');
      if (d.indexOf('61') === 0) d = '0' + d.slice(2);
      if (d.indexOf('0') !== 0) d = '0' + d;
      if (d.length === 10) {
        if (d.indexOf('04') === 0) return d.slice(0, 4) + ' ' + d.slice(4, 7) + ' ' + d.slice(7);
        return d.slice(0, 2) + ' ' + d.slice(2, 6) + ' ' + d.slice(6);
      }
      return p;
    };

    var icon = L.icon({
      iconUrl:
        'data:image/svg+xml;charset=UTF-8,' +
        encodeURIComponent(
          '<svg viewBox="0 0 38 54" width="38" height="54" xmlns="http://www.w3.org/2000/svg"><path d="M19 1C9 1 1 9 1 19c0 13 18 34 18 34s18-21 18-34C37 9 29 1 19 1z" fill="#2b4a25" stroke="#FFFFFF" stroke-width="2"/><g transform="translate(11.3,11.6) scale(0.62)" fill="none" stroke="#57b949" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 17.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"/><path d="M6 8v11a1 1 0 0 0 1.806 .591l3.694 -5.091v.055"/><path d="M6 8h15l-3.5 7l-7.1 -.747a4 4 0 0 1 -3.296 -2.493l-2.853 -7.13a1 1 0 0 0 -.928 -.63h-1.323"/></g></svg>',
        ),
      iconSize: [38, 54],
      iconAnchor: [19, 54],
      popupAnchor: [0, -54],
    });

    var popup = function (r) {
      var name = (r.Name || '').trim(),
        addr = (r.Address || '').trim(),
        sub = (r.Suburb || '').trim(),
        st = (r.State || '').trim(),
        pc = (r.Postcode || '').trim(),
        ph = (r.Phone || '').trim(),
        web = (r.Website || '').trim(),
        notes = (r.Notes || '').trim();
      var full = [addr, sub, [st, pc].filter(Boolean).join(' ')].filter(Boolean).join(', ');
      var h = '<div class="stockist-popup">';
      if (name) h += '<h3>' + esc(name) + '</h3>';
      if (full) h += '<p><strong>Address:</strong><br>' + esc(full) + '</p>';
      if (ph) {
        var td = ph.replace(/\D/g, '');
        h += '<p><strong>Phone:</strong> <a href="tel:+' + (td.indexOf('61') === 0 ? td : '61' + td.replace(/^0/, '')) + '">' + esc(fmtPhone(ph)) + '</a></p>';
      }
      if (web) {
        var u = web.indexOf('http') === 0 ? web : 'https://' + web;
        h += '<p><a href="' + esc(u) + '" target="_blank" rel="noopener noreferrer">Visit website</a></p>';
      }
      if (notes) h += '<p><em>' + esc(notes) + '</em></p>';
      return h + '</div>';
    };

    // THEME-ONLY (preserved delta): dragging is explicitly disabled — the
    // design is click-a-state-or-pin only (click, list-card click, "Near
    // me"), never freeform pan/zoom. The app never set this, which left
    // dragging at Leaflet's default `true`; combined with touchZoom:false it
    // made Leaflet hand pinch gestures back to the browser for native pinch-
    // zoom instead of either panning the map or doing nothing (see
    // leaflet.css's .leaflet-touch-drag rule). scrollWheelZoom/doubleClick/
    // boxZoom/touchZoom/keyboard/zoomControl stay off exactly as the app had
    // them.
    var map = L.map(el, {
      center: [-27, 133.4],
      zoom: 4,
      minZoom: 3,
      maxZoom: 9,
      // THEME-ONLY (preserved delta): zoomSnap 0 is what actually makes this
      // map fill its container. Leaflet defaults zoomSnap to 1, so fitBounds()
      // may only pick INTEGER zoom levels and rounds DOWN to the largest one
      // that fits — every media query in page-stockists.css was already
      // correct and the map still rendered at roughly half size, because the
      // container was never the constraint.
      //
      // Australia spans 41.5 of 360 degrees of longitude, so at zoom z it is
      // 0.1153 * 256 * 2^z pixels wide. In an 882px container that needs
      // z = 4.90; snapped down to 4 it draws 472px, i.e. 52% of the box, with
      // the rest dead green. A 331px mobile box needs 3.49, snaps to 3, draws
      // 236px. Both measured on the preview and both match the arithmetic.
      //
      // With zoomSnap 0 fitBounds may use fractional zoom and fills exactly.
      // zoomDelta then has to be set explicitly: it inherits from zoomSnap,
      // so leaving it would make the zoom controls step by 0.
      zoomSnap: 0,
      zoomDelta: 0.5,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      boxZoom: false,
      touchZoom: false,
      dragging: false,
      keyboard: false,
      zoomControl: false,
      maxBoundsViscosity: 1,
    });
    map.setMaxBounds(
      L.latLngBounds([
        [-46, 109],
        [-8, 158],
      ]),
    );
    // THEME-ONLY (preserved delta): fit the whole country to the container's
    // actual size instead of a hardcoded center/zoom. A fixed zoom 4 assumes
    // a wide container; Australia's ~41° longitude span doesn't fit inside a
    // narrow mobile container's width at that zoom, cropping the east coast
    // — and since dragging is now off (above), that crop was permanent, not
    // just an awkward default the user could pan past. minZoom is lowered to
    // 3 so fitBounds is free to pick whatever the container needs. AUS_VIEW
    // captures the result so "clear/deselect a state" flies back to the same
    // fitted view rather than a different hardcoded one.
    var AU_BOUNDS = L.latLngBounds([
      [-43.8, 112.5],
      [-9.5, 154],
    ]);
    // Was [10, 10]. Measured across four values at a 786x522 panel: 10 -> 65%
    // of the panel's width, 6 -> 66%, 2 -> 67%, 0 -> 68%, with height going
    // 93% -> 96% and no marker clipped at any of them. 2 keeps a hair off the
    // container's corner radius for the cost of one percent. This is the
    // ceiling for a fit that shows the whole country: the panel is 1.5:1 and
    // Australia fits at 1.06:1, so the leftover is width and no zoom setting
    // can reclaim it — only a squarer panel or a crop could.
    var AU_PAD = [2, 2];
    map.fitBounds(AU_BOUNDS, { padding: AU_PAD });
    var AUS_VIEW = { center: map.getCenter(), zoom: map.getZoom() };
    setTimeout(function () {
      map.invalidateSize();
      // Re-fit once the container's real post-layout size is available (the
      // synchronous fit above can run before CSS/webfonts settle the box) —
      // only while still on the untouched national view, so this can't
      // clobber an already-selected state or "near me" location.
      if (!selectedState && !userLoc) {
        map.fitBounds(AU_BOUNDS, { padding: AU_PAD });
        AUS_VIEW = { center: map.getCenter(), zoom: map.getZoom() };
      }
    }, 0);
    window.__smbmap = map;
    try {
      map.attributionControl.setPrefix('Leaflet');
    } catch (e) {}

    var stateShapes = [],
      allRows = [],
      selectedState = null;
    window.__markerByName = {};
    var order = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'ACT', 'NT'];
    var fullName = {
      NSW: 'New South Wales',
      VIC: 'Victoria',
      QLD: 'Queensland',
      SA: 'South Australia',
      WA: 'Western Australia',
      TAS: 'Tasmania',
      ACT: 'Australian Capital Territory',
      NT: 'Northern Territory',
    };
    var aliases = { ACT: 'ACT', 'AUSTRALIAN CAPITAL TERRITORY': 'ACT', 'JERVIS BAY': 'ACT' };
    var codeFromName = function (n) {
      var u = (n || '').toUpperCase();
      if (aliases[u]) return aliases[u];
      for (var k in fullName) if (fullName[k].toUpperCase() === u || k === u) return k;
      return u;
    };
    var searchQuery = '',
      userLoc = null;
    var haversine = function (a, b, c, d) {
      var R = 6371,
        t = function (x) {
          return (x * Math.PI) / 180;
        };
      var dLat = t(c - a),
        dLng = t(d - b);
      var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(t(a)) * Math.cos(t(c)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(x));
    };
    var card = function (r) {
      var nm = esc((r.Name || '').trim());
      var distStr =
        typeof r.__dist === 'number'
          ? '<span style="font-family: var(--font-mono); font-weight: 700; font-size: var(--label-size-md); letter-spacing: .06em; color: var(--green-vivid); white-space: nowrap;">' +
            (r.__dist < 1 ? '<1' : Math.round(r.__dist)) +
            ' km</span>'
          : '';
      var meta = esc([(r.Suburb || '').trim(), (r.State || '').trim(), (r.Postcode || '').trim()].filter(Boolean).join(' · '));
      var phone = fmtPhone((r.Phone || '').trim());
      var web = (r.Website || '').trim();
      var head = web
        ? '<a href="' +
          esc(web.indexOf('http') === 0 ? web : 'https://' + web) +
          '" target="_blank" rel="noopener noreferrer" style="font-family: var(--font-heading); font-weight: 600; font-size: 15px; color: var(--cream-on-dark); text-decoration: none;">' +
          nm +
          '</a>'
        : '<div style="font-family: var(--font-heading); font-weight: 600; font-size: 15px; color: var(--cream-on-dark);">' + nm + '</div>';
      return (
        '<div data-stk="' +
        esc((r.Name || '').trim()) +
        '" style="background: rgb(8 14 8 / .25); border: 1px solid rgb(181 207 168 / .2); border-radius: var(--radius-lg); padding: 15px 17px; cursor: pointer;"><div style="display: flex; justify-content: space-between; align-items: baseline; gap: 10px;">' +
        head +
        distStr +
        '</div><div style="font-family: var(--font-mono); font-weight: 700; font-size: 11px; letter-spacing: .05em; color: var(--green-sage); margin-top: 3px;">' +
        meta +
        '</div>' +
        (phone
          ? '<div style="font-family: var(--font-mono); font-weight: 700; font-size: 11px; letter-spacing: .05em; color: var(--green-sage); margin-top: 2px;">' +
            esc(phone) +
            '</div>'
          : '') +
        '</div>'
      );
    };
    var renderList = function () {
      var listEl = document.getElementById('stockist-list'),
        labelEl = document.getElementById('stockist-filter-label'),
        resetEl = document.getElementById('stockist-reset');
      if (!listEl) return;
      var rows = selectedState
        ? allRows.filter(function (r) {
            return (r.State || '').trim().toUpperCase() === selectedState;
          })
        : allRows.slice();
      var q = searchQuery.trim().toLowerCase();
      if (q)
        rows = rows.filter(function (r) {
          return (
            [r.Name, r.Suburb, r.State, r.Postcode, r.Address]
              .map(function (v) {
                return (v || '').toLowerCase();
              })
              .join(' ')
              .indexOf(q) >= 0
          );
        });
      if (userLoc)
        rows.forEach(function (r) {
          var la = parseFloat(r.Latitude),
            ln = parseFloat(r.Longitude);
          r.__dist = isFinite(la) && isFinite(ln) ? haversine(userLoc.lat, userLoc.lng, la, ln) : Infinity;
        });
      else
        rows.forEach(function (r) {
          delete r.__dist;
        });
      var html = '';
      if (!rows.length) {
        html =
          '<div style="font-family: var(--font-body); font-size: 14px; line-height: 1.6; color: var(--green-sage); padding: 8px 2px;">No stockists match — try a different search, or <a href="/pages/contact" style="color: var(--green-vivid);">enquire about ordering</a>.</div>';
      } else if (userLoc) {
        rows.sort(function (a, b) {
          return a.__dist - b.__dist;
        });
        html =
          '<div style="font-family: var(--font-mono); font-weight: 700; font-size: var(--label-size-md); letter-spacing: .14em; text-transform: uppercase; color: var(--green-vivid); margin: 0 0 2px;">Nearest to you</div>' +
          rows.map(card).join('');
      } else {
        var groups = {};
        rows.forEach(function (r) {
          var st = (r.State || '').trim().toUpperCase() || 'OTHER';
          (groups[st] = groups[st] || []).push(r);
        });
        var keys = order
          .filter(function (k) {
            return groups[k];
          })
          .concat(
            Object.keys(groups).filter(function (k) {
              return order.indexOf(k) < 0;
            }),
          );
        keys.forEach(function (k) {
          html +=
            '<div style="font-family: var(--font-mono); font-weight: 700; font-size: var(--label-size-md); letter-spacing: .14em; text-transform: uppercase; color: var(--green-vivid); margin: 6px 0 0;">' +
            esc(fullName[k] || k) +
            '</div>' +
            groups[k].map(card).join('');
        });
      }
      listEl.innerHTML = html;
      if (labelEl) {
        var base = userLoc ? 'Nearest first' : selectedState ? fullName[selectedState] || selectedState : 'All stockists';
        labelEl.textContent = base + ' · ' + rows.length;
      }
      if (resetEl) resetEl.style.display = selectedState || userLoc || q ? 'inline-block' : 'none';
    };
    var ptIn = function (lng, lat, rings) {
      var inside = false;
      for (var ri = 0; ri < rings.length; ri++) {
        var r = rings[ri];
        for (var i = 0, j = r.length - 1; i < r.length; j = i++) {
          var xi = r[i][0],
            yi = r[i][1],
            xj = r[j][0],
            yj = r[j][1];
          if (yi > lat !== yj > lat && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi) inside = !inside;
        }
      }
      return inside;
    };
    var hitState = function (ll) {
      for (var i = 0; i < stateShapes.length; i++) if (ptIn(ll.lng, ll.lat, stateShapes[i].rings)) return stateShapes[i].name;
      return null;
    };
    var bbox = function (s) {
      var mnx = 999,
        mny = 999,
        mxx = -999,
        mxy = -999;
      s.rings.forEach(function (r) {
        r.forEach(function (p) {
          if (p[0] < mnx) mnx = p[0];
          if (p[0] > mxx) mxx = p[0];
          if (p[1] < mny) mny = p[1];
          if (p[1] > mxy) mxy = p[1];
        });
      });
      return { mnx: mnx, mny: mny, mxx: mxx, mxy: mxy };
    };
    var zoomToState = function (s) {
      var b = bbox(s);
      var spanLng = Math.max(0.3, b.mxx - b.mnx),
        spanLat = Math.max(0.3, b.mxy - b.mny);
      var sz = map.getSize();
      var zx = Math.log((sz.x * 360) / (256 * spanLng * 1.25)) / Math.LN2;
      var zy = Math.log((sz.y * 360) / (256 * spanLat * 1.25)) / Math.LN2;
      var z = Math.min(zx, zy);
      z = Math.max(4, Math.min(9, Math.round(z * 10) / 10));
      map.flyTo([(b.mny + b.mxy) / 2, (b.mnx + b.mxx) / 2], z, { duration: 0.7 });
    };
    var setHighlight = function (code) {
      var layers = window.__stateLayers || {};
      Object.keys(layers).forEach(function (k) {
        try {
          layers[k].setStyle({ fillOpacity: k === code ? 0.18 : 0 });
        } catch (e) {}
      });
    };
    /* THEME-ONLY (preserved delta) — state-filter fallback.
       zoomToState needs a polygon from the states GeoJSON. When that fetch fails
       (the basemap-fallback branch), stateShapes stays empty and the app's
       applyFilter simply does nothing to the map (stockistMapBoot.client.ts:
       380-383) — picking a state re-renders the list while the map sits at the
       national view, which reads as a dead control. Fit the selected state's own
       stockists instead, using the app's own declared CONFIG.fit options. Only
       ever reached when no polygon is available, so with the GeoJSON present the
       zoom behaviour is byte-identical to the app's. */
    var fitSelected = function () {
      var pts = [];
      allRows.forEach(function (r) {
        if ((r.State || '').trim().toUpperCase() !== selectedState) return;
        var la = parseFloat(r.Latitude),
          ln = parseFloat(r.Longitude);
        if (isFinite(la) && isFinite(ln)) pts.push([la, ln]);
      });
      if (!pts.length) return;
      try {
        map.flyToBounds(L.latLngBounds(pts), {
          padding: L.point(CONFIG.fit.padding),
          maxZoom: CONFIG.fit.maxZoom,
          duration: 0.7,
        });
      } catch (e) {}
    };
    var applyFilter = function (name) {
      map.closePopup();
      selectedState = name ? codeFromName(name) : null;
      var selEl = document.getElementById('stockist-state');
      if (selEl) selEl.value = selectedState || '';
      renderList();
      setHighlight(selectedState);
      if (selectedState) {
        var s = null;
        for (var i = 0; i < stateShapes.length; i++)
          if (codeFromName(stateShapes[i].name) === selectedState) {
            s = stateShapes[i];
            break;
          }
        if (s) zoomToState(s);
        else fitSelected();
      } else {
        map.flyTo(AUS_VIEW.center, AUS_VIEW.zoom, { duration: 0.7 });
      }
    };
    var __lastSel = 0;
    var selectFromLatLng = function (ll) {
      var now = new Date().getTime();
      if (now - __lastSel < 350) return;
      var n = hitState(ll);
      if (n) {
        __lastSel = now;
        applyFilter(codeFromName(n) === selectedState ? null : n);
      }
    };
    map.on('click', function (e) {
      selectFromLatLng(e.latlng);
    });
    map.getContainer().addEventListener('click', function (ev) {
      var target = ev.target;
      if (target && target.closest && target.closest('.leaflet-marker-icon, .leaflet-popup, .leaflet-control')) return;
      var rect = map.getContainer().getBoundingClientRect();
      selectFromLatLng(map.containerPointToLatLng(L.point(ev.clientX - rect.left, ev.clientY - rect.top)));
    });
    var listEl0 = document.getElementById('stockist-list');
    if (listEl0)
      listEl0.addEventListener('click', function (ev) {
        var target = ev.target;
        if (target && target.closest && target.closest('a')) return;
        var cardEl = target && target.closest ? target.closest('[data-stk]') : null;
        if (!cardEl) return;
        var m = window.__markerByName[cardEl.getAttribute('data-stk')];
        if (m) {
          map.setView(m.getLatLng(), Math.max(map.getZoom(), 6), { animate: true });
          m.openPopup();
        }
      });
    // Near me is the primary button until it is on, then the secondary one:
    // the theme's two button designs, never a colour of its own.
    function setNearOn(el, on) {
      el.classList.toggle('smb-btn--primary', !on);
      el.classList.toggle('smb-btn--secondary', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var rb = document.getElementById('stockist-reset');
    if (rb)
      rb.onclick = function () {
        searchQuery = '';
        userLoc = null;
        var sel = document.getElementById('stockist-state');
        if (sel) sel.value = '';
        var nb = document.getElementById('stockist-near');
        if (nb) {
          setNearOn(nb, false);
        }
        try {
          if (window.__youMarker) {
            map.removeLayer(window.__youMarker);
            window.__youMarker = null;
          }
        } catch (e) {}
        applyFilter(null);
      };
    var selCtl = document.getElementById('stockist-state');
    if (selCtl)
      selCtl.addEventListener('change', function () {
        applyFilter(selCtl.value || null);
      });
    var nb = document.getElementById('stockist-near');
    if (nb)
      nb.onclick = function () {
        if (userLoc) {
          userLoc = null;
          setNearOn(nb, false);
          renderList();
          return;
        }
        if (!navigator.geolocation) {
          nb.textContent = 'Unavailable';
          return;
        }
        var label0 = nb.innerHTML;
        nb.textContent = 'Locating…';
        nb.disabled = true;
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            userLoc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
            nb.innerHTML = label0;
            nb.disabled = false;
            setNearOn(nb, true);
            selectedState = null;
            setHighlight(null);
            renderList();
            try {
              if (window.__youMarker) map.removeLayer(window.__youMarker);
              window.__youMarker = L.circleMarker([userLoc.lat, userLoc.lng], {
                radius: 7,
                color: '#fff',
                weight: 2,
                fillColor: '#2a6fdb',
                fillOpacity: 1,
              }).addTo(map);
            } catch (e) {}
            map.flyTo([userLoc.lat, userLoc.lng], 7, { duration: 0.8 });
          },
          function () {
            nb.innerHTML = label0;
            nb.disabled = false;
            nb.textContent = 'Denied';
            setTimeout(function () {
              nb.innerHTML = label0;
            }, 1800);
          },
          { enableHighAccuracy: true, timeout: 8000 },
        );
      };

    /* THEME-ONLY (preserved delta) — guaranteed ground.
       The app adds the CARTO basemap in exactly one place: the .catch() of the
       states-GeoJSON fetch (stockistMapBoot.client.ts:717-722). The intended
       ground is the turf image overlay, added only in tryImg's probe.onload
       (…:700-710). That leaves a branch with NO ground at all — GeoJSON resolves
       but the turf texture can't be loaded in any of the four extensions — where
       tryImg() falls straight through to addBorders(). The map then shows just
       #stockists-map's own background (page-stockists.css:58-75: sage grid over
       var(--green-deep) #2b4a25) and the pins, whose teardrop fill is that exact
       same #2b4a25, read as bare white outlines. Hoisted and idempotent so the
       basemap covers that branch too; layer options are byte-identical to the
       app's, so nothing changes when the turf overlay does load. */
    var basemapAdded = false;
    var ensureBasemap = function () {
      if (basemapAdded) return;
      basemapAdded = true;
      try {
        L.tileLayer(CONFIG.tile.url, { attribution: CONFIG.tile.attribution, maxZoom: CONFIG.tile.maxZoom }).addTo(map);
      } catch (e) {}
    };

    fetch('https://raw.githubusercontent.com/tonywr71/GeoJson-Data/master/australian-states.json')
      .then(function (r) {
        if (!r.ok) throw new Error('geo');
        return r.json();
      })
      .then(function (geo) {
        var sr = function (ring) {
          var o = [],
            l = null;
          for (var i = 0; i < ring.length; i++) {
            var p = ring[i],
              x = Math.round(p[0] * 100) / 100,
              y = Math.round(p[1] * 100) / 100;
            if (!l || l[0] !== x || l[1] !== y) {
              o.push([x, y]);
              l = [x, y];
            }
          }
          return o.length >= 4 ? o : ring;
        };
        var coords = [],
          minLat = 90,
          maxLat = -90,
          minLng = 180,
          maxLng = -180;
        (geo.features || []).forEach(function (f) {
          var g = f.geometry;
          if (!g) return;
          var ps = g.type === 'Polygon' ? [g.coordinates] : g.type === 'MultiPolygon' ? g.coordinates : [];
          ps.forEach(function (poly) {
            var rings = poly.map(sr);
            coords.push(rings);
            rings.forEach(function (r) {
              r.forEach(function (pt) {
                if (pt[0] < minLng) minLng = pt[0];
                if (pt[0] > maxLng) maxLng = pt[0];
                if (pt[1] < minLat) minLat = pt[1];
                if (pt[1] > maxLat) maxLat = pt[1];
              });
            });
          });
        });
        stateShapes = (geo.features || []).map(function (f) {
          var g = f.geometry || {};
          var rings = [];
          var ps = g.type === 'Polygon' ? [g.coordinates] : g.type === 'MultiPolygon' ? g.coordinates : [];
          ps.forEach(function (poly) {
            poly.forEach(function (r) {
              rings.push(r);
            });
          });
          return { name: (f.properties && f.properties.STATE_NAME) || '', rings: rings };
        });
        var W = maxLng - minLng;
        var clipId = 'smbLandClip';
        if (!document.getElementById(clipId)) {
          var yM = function (lat) {
            return Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 360));
          };
          var yTop = yM(maxLat),
            yRange = yM(maxLat) - yM(minLat);
          var ccw = function (r) {
            var a = 0;
            for (var i = 0, n = r.length; i < n; i++) {
              var p = r[i],
                q = r[(i + 1) % n];
              a += p[0] * q[1] - q[0] * p[1];
            }
            return a >= 0 ? r : r.slice().reverse();
          };
          var d = '';
          coords.forEach(function (rings) {
            rings.forEach(function (r0) {
              var r = ccw(r0);
              r.forEach(function (pt, i) {
                d += (i === 0 ? 'M' : 'L') + ((pt[0] - minLng) / W).toFixed(4) + ' ' + ((yTop - yM(pt[1])) / yRange).toFixed(4) + ' ';
              });
              d += 'Z ';
            });
          });
          var NS = 'http://www.w3.org/2000/svg';
          var svg = document.createElementNS(NS, 'svg');
          svg.setAttribute('width', '0');
          svg.setAttribute('height', '0');
          svg.style.position = 'absolute';
          var cp = document.createElementNS(NS, 'clipPath');
          cp.setAttribute('id', clipId);
          cp.setAttribute('clipPathUnits', 'objectBoundingBox');
          var path = document.createElementNS(NS, 'path');
          path.setAttribute('d', d);
          path.setAttribute('clip-rule', 'nonzero');
          path.setAttribute('fill-rule', 'nonzero');
          cp.appendChild(path);
          svg.appendChild(cp);
          document.body.appendChild(svg);
        }
        var ausBounds = [
          [minLat, minLng],
          [maxLat, maxLng],
        ];
        var base = 'https://cdn.shopify.com/s/files/1/0657/3493/4637/files/smellbgone-artificial-turf-top-down';
        var exts = ['.png', '.jpg', '.webp', '.jpeg'];
        window.__stateLayers = {};
        var drawBorders = function () {
          Object.keys(window.__stateLayers).forEach(function (k) {
            try {
              map.removeLayer(window.__stateLayers[k]);
            } catch (e) {}
          });
          window.__stateLayers = {};
          var rnd = L.svg({ padding: 0.5 });
          (geo.features || []).forEach(function (f) {
            var codeKey = codeFromName((f.properties && f.properties.STATE_NAME) || '');
            try {
              var lyr = L.geoJSON(f, {
                interactive: false,
                renderer: rnd,
                style: { stroke: true, color: '#ffffff', weight: 1, opacity: 0.85, fill: true, fillColor: '#57b949', fillOpacity: 0 },
              }).addTo(map);
              window.__stateLayers[codeKey] = lyr;
            } catch (e) {}
          });
          if (selectedState) setHighlight(selectedState);
        };
        window.__drawStateBorders = drawBorders;
        var addBorders = function () {
          map.invalidateSize();
          drawBorders();
          map.whenReady(function () {
            setTimeout(function () {
              map.invalidateSize();
              drawBorders();
            }, 350);
          });
          [700, 1400].forEach(function (t) {
            setTimeout(function () {
              if (Object.keys(window.__stateLayers).length < (geo.features || []).length) {
                map.invalidateSize();
                drawBorders();
              }
            }, t);
          });
        };
        // THEME-ONLY: the turf ground ships as a theme asset (the section passes
        // its URL via data-turf-src), so the texture no longer depends on a
        // store Files entry. The CDN extension probe remains as a fallback.
        var themeTurf = el.getAttribute('data-turf-src');
        var candidates = [];
        if (themeTurf) candidates.push(themeTurf);
        exts.forEach(function (ext) {
          candidates.push(base + ext);
        });
        var tryImg = function (i) {
          // No turf texture available → fall back to the basemap so the map is
          // never a bare container (see ensureBasemap above).
          if (i >= candidates.length) {
            ensureBasemap();
            addBorders();
            return;
          }
          var probe = new Image();
          probe.onload = function () {
            var ov = L.imageOverlay(probe.src, ausBounds, { interactive: false, className: 'smb-turf' }).addTo(map);
            var elx = ov.getElement();
            if (elx) {
              elx.style.clipPath = 'url(#' + clipId + ')';
              elx.style.webkitClipPath = 'url(#' + clipId + ')';
            }
            addBorders();
          };
          probe.onerror = function () {
            tryImg(i + 1);
          };
          probe.src = candidates[i];
        };
        tryImg(0);
      })
      .catch(function () {
        ensureBasemap();
      });

    var clusterPin = function (n) {
      var svg =
        '<svg viewBox="0 0 38 54" width="38" height="54" xmlns="http://www.w3.org/2000/svg"><path d="M19 1C9 1 1 9 1 19c0 13 18 34 18 34s18-21 18-34C37 9 29 1 19 1z" fill="#2b4a25" stroke="#ffffff" stroke-width="2"/><text x="19" y="19" text-anchor="middle" dy="0.35em" fill="#57b949" font-family="\'Bricolage Grotesque\', sans-serif" font-weight="700" font-size="14" letter-spacing="-0.02em">' +
        n +
        '</text></svg>';
      return L.divIcon({ html: svg, className: 'smb-cluster-icon', iconSize: [38, 54], iconAnchor: [19, 54] });
    };
    var cluster = L.markerClusterGroup(
      Object.assign({}, CONFIG.cluster, {
        iconCreateFunction: function (c) {
          return clusterPin(c.getChildCount());
        },
      }),
    );
    var num = function (v) {
      var n = parseFloat(String(v).trim());
      return isFinite(n) ? n : null;
    };
    var rows = stockists.map(toRow);
    allRows = rows.filter(function (r) {
      return (r.Name || '').trim();
    });
    var bounds = [],
      ms = [];
    rows.forEach(function (row) {
      var la = num(row.Latitude),
        ln = num(row.Longitude);
      if (la === null || ln === null) return;
      var m = L.marker([la, ln], { icon: icon, title: row.Name || 'Stockist' });
      m.bindPopup(popup(row), { maxWidth: 300 });
      ms.push(m);
      var nm = (row.Name || '').trim();
      window.__markerByName[nm] = m;
      bounds.push([la, ln]);
    });
    try {
      if (bounds.length) {
        map.addLayer(cluster);
        cluster.addLayers(ms);
      }
    } catch (err) {}
    [60, 250, 600, 1200].forEach(function (t) {
      setTimeout(function () {
        map.invalidateSize();
        // Re-fit after each invalidateSize, not just on resize. On a cold load
        // the container is still settling (webfonts, the hero image above it),
        // so the size Leaflet fitted against at t=0 is not the final one —
        // invalidateSize alone tells it the box changed but keeps the old
        // centre/zoom. Guarded like every other re-fit here so it can never
        // discard a selected state or a "near me" result.
        if (!selectedState && !userLoc) {
          map.fitBounds(AU_BOUNDS, { padding: AU_PAD });
          AUS_VIEW = { center: map.getCenter(), zoom: map.getZoom() };
        }
        if (window.__drawStateBorders && (!window.__stateLayers || Object.keys(window.__stateLayers).length < 8)) window.__drawStateBorders();
      }, t);
    });
    applyFilter(null);
    el.classList.remove('loading');

    var onResize = function () {
      clearTimeout(window.__smbRsz);
      window.__smbRsz = setTimeout(function () {
        map.invalidateSize();
        // ...and re-fit the country to the container's NEW size. invalidateSize
        // alone only tells Leaflet the box changed; it keeps the old
        // centre/zoom, so a narrower box crops Australia. Dragging is disabled
        // (see the map options above), so that crop is permanent — the user
        // cannot pan the east coast back into view after a resize or a device
        // rotation. Guarded exactly like the boot-time re-fit a few lines
        // below the initial fitBounds: only while still on the untouched
        // national view, so a resize can't throw away a state the user
        // selected or a "near me" result.
        if (!selectedState && !userLoc) {
          map.fitBounds(AU_BOUNDS, { padding: AU_PAD });
          AUS_VIEW = { center: map.getCenter(), zoom: map.getZoom() };
        }
      }, 250);
    };
    window.addEventListener('resize', onResize);
  }

  function init() {
    var mapEl = document.getElementById('stockists-map');
    if (!mapEl || typeof L === 'undefined' || mapEl._init) return;
    var data = [];
    var jsonEl = document.querySelector('[data-stockists-json]');
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      data = [];
    }
    boot(data);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
